import { STORAGE_KEYS } from './constants';

export interface TokenSet {
  accessToken: string | null;
  idToken: string | null;
  refreshToken: string | null;
}

export const getTokens = (): TokenSet => ({
  accessToken: localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN),
  idToken: localStorage.getItem(STORAGE_KEYS.ID_TOKEN),
  refreshToken: localStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN),
});

export const getRefreshToken = (): string | null =>
  localStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN);

export const setTokens = (
  accessToken: string,
  idToken: string,
  refreshToken?: string | null
): void => {
  localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, accessToken);
  localStorage.setItem(STORAGE_KEYS.ID_TOKEN, idToken);

  if (refreshToken)
    localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, refreshToken);
};

export const removeTokens = () => {
  localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
  localStorage.removeItem(STORAGE_KEYS.ID_TOKEN);
  localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN);
};

/** Remove access + ID only (refresh token kept for Cognito refresh attempts). */
export const removeAccessAndIdTokens = () => {
  localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
  localStorage.removeItem(STORAGE_KEYS.ID_TOKEN);
};
